import { SocietyCorporateId } from 'types/Society';

export const contactsByCorporateId = {
  [SocietyCorporateId.DEFAULT]: {
    societyName: 'Sttok Support',
    societyEmail: 'info@sttok.com',
    supportSource: 'sttok.com',
    showSupportTypeField: true,
    showCategoryField: true,
    showPriorityField: true,
    showAttachmentsField: true,
    hasWhiteBranding: false,
    emailTheme: null,
  },
  [SocietyCorporateId.AXA]: {
    societyName: 'Agrupació AMCI',
    societyEmail: 'accionista@gacm.es',
    supportSource: 'el Portal del Accionista',
    supportFromName: 'Portal del Accionista',
    supportFromEmail: 'portal.accionista@sttok.com',
    showSupportTypeField: false,
    showCategoryField: false,
    showPriorityField: false,
    showAttachmentsField: true,
    hasWhiteBranding: true,
    emailTheme: {
      logo: 'https://resources.sttok.com/images/logo-gacme.png',
      frameColor: '#f5f6fa',
      headingsColor: '#000000',
      bodyTextColor: '#8094ae',
      linkColor: '#000000',
      buttonColor: '#000000',
      buttonTextColor: '#ffffff',
      buttonRounded: '4px',
    },
    disclaimers: {
      issueDetails: 'DisclaimerAxa1',
      issueMoreInfo: 'DisclaimerAxa2',
    },
  },
  [SocietyCorporateId.ASG]: {
    societyName: 'AXA',
    societyEmail: 'buzon.legal.corporativo@axa.es',
    supportSource: 'el Portal del Accionista',
    supportFromName: 'Portal del Accionista',
    supportFromEmail: 'portal.accionista@sttok.com',
    showSupportTypeField: false,
    showCategoryField: false,
    showPriorityField: false,
    showAttachmentsField: true,
    hasWhiteBranding: true,
    emailTheme: {
      logo: 'https://resources.sttok.com/images/logo-axa-header.svg',
      frameColor: '#f5f6fa',
      headingsColor: '#000000',
      bodyTextColor: '#8094ae',
      linkColor: '#000000',
      buttonColor: '#000000',
      buttonTextColor: '#ffffff',
      buttonRounded: '4px',
    },
    disclaimers: {
      issueDetails: 'DisclaimerAxa1',
      issueMoreInfo: 'DisclaimerAxa2',
    },
  },
};
